import { LoanType } from './LoanType';

export const LoanTypeOptions = [
    {
        id: '',
        name: 'Select Loan Type...',
        shortName: '',
        sortOrder: 0,
        active: true,
    },
    {
        id: LoanType.Construction,
        name: 'Construction',
        shortName: 'Const.',
        sortOrder: 1,
        active: true,
    },
    {
        id: LoanType.Rental,
        name: 'Rental',
        shortName: 'Rental',
        sortOrder: 4,
        active: true,
    },
    {
        id: LoanType.BuildRent,
        name: 'Build Rent',
        shortName: 'Bld Rent',
        sortOrder: 5,
        active: true,
    },
    {
        id: LoanType.Model,
        name: 'Model',
        shortName: 'Model',
        sortOrder: 9,
        active: true,
    },
    {
        id: LoanType.Land,
        name: 'Land',
        shortName: 'Land',
        sortOrder: 8,
        active: true,
    },
    {
        id: LoanType.FixFlip,
        name: 'Fix-Flip',
        shortName: 'Fx-Flp',
        sortOrder: 6,
        active: true,
    },
    {
        id: LoanType.MasterNote,
        name: 'Master Note',
        shortName: 'Mstr Nte',
        sortOrder: 0,
        active: true,
    },
    {
        id: LoanType.SubNoteConstruction,
        name: 'Construction LOC',
        shortName: 'Const. LOC',
        sortOrder: 2,
        active: true,
    },
    {
        id: LoanType.SubNoteFixFlip,
        name: 'Fix-Flip LOC',
        shortName: 'Fix-Flip LOC',
        sortOrder: 7,
        active: false,
    },
    {
        id: LoanType.Bridge,
        name: 'Bridge',
        shortName: 'Bridge',
        sortOrder: 3,
        active: true,
    },
];
